import SearchParamsBase from '../../../Elements/SearchParamsBase';

export default class ClientPaymentClientInvoiceSearchParams extends SearchParamsBase {
  static saveType = 'ClientPaymentClientInvoiceSearchParams';
  constructor(cpId, type) {
    super();
    this.ClientPaymentIds = [cpId];
    this.Type = type;
  }

  initialize() {
    this.ClientPaymentIds = [];
    this.Type = '';
  }
}
